import { Model } from './Model';

export interface AddOnType {
    id: number;
    label: string;
    tooltip: string;
    cost: number;
    cost_type: number;
    published: number;
    is_design_addon: boolean;
}

export const AddOn = Model('AddOns', { endpoint: 'apparel-addons' })`
    id:Int;
    label:String;
    tooltip:String;
    cost: float;
    cost_type: int;
    published: Int;
`;
